
import common from '@/tools/common'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
methods: {
async loadData () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/StatsParam/Group')
this.GridData = queryPromise.data.map(function (item) {
return {text: item.G_NAME, link: 'UnitConvertQuery?code=' + item.ID, icon: item.G_NAME + '.png'}
}).sort((a, b) => b.text.localeCompare(a.text, 'zh'))
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message
})
}
}
},
data () {
return {
height: window.innerHeight - 46 - 53,
GridData: []
}
},
beforeCreate: function () {
var power = common.getUrlParam('power')
common.setPower(power)
/* 将权限记录入session */
},
created: function () {




},
async activated () {
await this.loadData()
}
}



// WEBPACK FOOTER //
// ./src/components/UnitConvert.vue